import React, { useEffect } from "react";
import { HashRouter as Router, Routes, Route  } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import './Assets/scss/main.scss';

import { getBaseUrl, getUrlParamsObject, getParams, getProvince, setCursorWaiting } from './utils';

import BuildHelper from "./Helpers/BuildHelper";
import NavHelper from './Helpers/navhelper';
import SummaryCalculator from './Helpers/summarycalculator';
import { openModal } from './Helpers/helpers';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import { Nav } from './Components/3_Organisms/Nav/Nav';
import { Modal } from './Components/3_Organisms/Modal/Modal';
import { AccessoriesList } from './Components/3_Organisms/AccessoriesList/AccessoriesList'
import { VehiclePage } from './Components/5_Pages/Vehicles/Vehicles';
import { TrimsPage } from './Components/5_Pages/Trim/Trim';
import { SummaryPage } from './Components/5_Pages/Summary/Summary';
import { Options } from './Components/5_Pages/Option/Option';
import { Colours } from './Components/5_Pages/Colours/Colours';
import { Wheels } from './Components/5_Pages/Wheels/Wheels';
import { Connectivity } from './Components/5_Pages/Connectivity/Connectivity';
import { PaymentsPage } from './Components/5_Pages/Payments/Payments';
import { Protection } from './Components/5_Pages/Protection/Protection';

function App() {
  const { t, i18n } = useTranslation(['general']);

  const urlParams = getUrlParamsObject();
  const buildId = urlParams.build;

  window.summaryCalculator = new SummaryCalculator().reloadStoredData();

  const savedCarline = JSON.parse(sessionStorage.getItem('SelectedVehicle')) ?.carline;
  const savedCarYear = JSON.parse(sessionStorage.getItem('SelectedVehicle')) ?.year;

  const getProvinceInUrl = () => {
    const params = getParams(window.location.hash);
    if(params.prov_code) {
      return params.prov_code[0];
    }

    return undefined
  }

  /*const getRequestedLanguageInUrl = () => {
    const params = getParams(window.location.hash);
    if(params.lang_code) {
      return params.lang_code[0];
    }

    return undefined
  }*/

  const currentProvince = document.querySelector('meta[name="data-region"]').content;
  const requestedProvince = getProvinceInUrl();

  //const currentLanguage = document.querySelector('meta[name="data-language"]').content;
  //const requestedLanguage = getRequestedLanguageInUrl();

  // Force a CMS redirect so that it can change province / language behind the scenes
  if (window.location.hash && (requestedProvince !== undefined && requestedProvince !== currentProvince)/* && (requestedLanguage !== undefined && requestedLanguage !== currentLanguage)*/) {
    const newLocation = window.location.origin + window.location.pathname + "?changeProvince=" + encodeURIComponent(window.location.origin + window.location.pathname +window.location.hash);
    window.location = newLocation;
  }

  // Rewrite the url after the redirect
  if (urlParams['changeProvince']) {
    window.summaryCalculator._apiService.province = currentProvince;
    window.summaryCalculator._tcciService.province = currentProvince;    
    window.history.pushState({}, document.title, decodeURIComponent(urlParams['changeProvince']));
  }

  // Override onchange behavior for the region selector
  document.addEventListener('DOMContentLoaded', () => {
    window.handleSelectChange = async () => {
      const select = document.getElementById('region-selector-dropdown');

      const newProvince = select.value;
      //console.log(newProvince);

      window.summaryCalculator._apiService.province = newProvince;
      window.summaryCalculator._tcciService.province = newProvince;
      
      const waitScreen = document.querySelector('div.loading');
      
      setCursorWaiting(true);
      // Display wait screen
      if(waitScreen) {
        waitScreen.classList.add('visible');
      }

      // DO NOT REMOVE THIS LINE, USED TO RELOAD FOR THE EV REBATE
      await window.summaryCalculator.forceReloadVehicle();

      setCursorWaiting(false);
      // Hide wait screen
      if(waitScreen) {
        waitScreen.classList.remove('visible');
      }

      // Set the regEx for prov_code replacement
      const provCodePattern = /prov_code=[^&]*/;
      
      // Replace the prov_code parameter
      let updatedUrl = window.location.href.replace(provCodePattern, `prov_code=${newProvince}`);

      // Update the url in the address bar before submit
      window.history.pushState({}, document.title, updatedUrl);
      
      const form = document.getElementById('region-selector');
      form.submit();
    };

    const languageLink = document.querySelector('#region-language-link');

    window.handleLanguageChange = async (e) => {
      const newLocation = languageLink.href;

      e.preventDefault();
      e.stopPropagation();

      const newLanguage = languageLink.text;

      const waitScreen = document.querySelector('div.loading');

      // Display the wait screen while loading
      if(waitScreen) {
        waitScreen.classList.add('visible');
      }
      
      window.summaryCalculator._apiService.language = newLanguage;
      window.summaryCalculator._tcciService.language = newLanguage;

      await window.summaryCalculator.forceReloadVehicle();
  
      // Hide wait screen
      if(waitScreen) {
        waitScreen.classList.remove('visible');
      }

      window.location = newLocation;
    };
    
    if (languageLink) {
      languageLink.addEventListener('click', window.handleLanguageChange, false);
    }

  });


  useEffect(() => {
    const cssFile = document.createElement("link");
    const scriptFile = document.createElement("script");
    
    
    cssFile.href = window.location.host.indexOf("localhost") === -1 ? getBaseUrl() + process.env.REACT_APP_GLOBALASSETS_CSS : '/forms/main.css';
    cssFile.rel = "stylesheet";
    document.head.appendChild(cssFile);

    scriptFile.src = window.location.host.indexOf("localhost") === -1 ? getBaseUrl() + process.env.REACT_APP_GLOBALASSETS_JS : '/forms/main.js';
    document.body.appendChild(scriptFile);

  }, [])

  if (window.location.hash) {
    if (window.location.hash.split('/')[1].substring(0, 1) != '?' && savedCarline) {
      const carYearHash = window.location.hash.split('/')[1];
      const carlineHash = window.location.hash.split('/')[2];
      if (carYearHash != savedCarYear || carlineHash != savedCarline) {
        console.log(carYearHash, carlineHash, savedCarYear, savedCarline);
        window.summaryCalculator.reset(true);
      }
    }
  }

  return (
    <Router>
      <div className={`App mzBuildandPrice ${window.location.host.indexOf("localhost") === -1 && window.bnp_retailer_mode ? 'retailer' : ''}`}>
        <header className="App-header">
        </header>
        <div className="App-container">
          <Routes>
            <Route exact path="/" element={
              buildId ? (
                <BuildHelper buildId={buildId} />
              ) : (
                  <VehiclePage key="vehiclePage" />
                )} />
            <Route exact path="/:year/:carline" element={<TrimsPage key="trimPage" />} />
            <Route exact path="/:year/:carline/:trim" element={<Options />} />
            <Route exact path="/:year/:carline/:trim/:model/:option" element={<Options />} />
            <Route exact path="/:year/:carline/:trim/:model/:packageCode/colours" element={<Colours />} />
            <Route exact path="/:year/:carline/:trim/:model/:packageCode/wheels" element={<Wheels />} />
            <Route exact path="/:year/:carline/:trim/:model/:packageCode/connectivity" element={<Connectivity />} />
            <Route exact path="/:year/:carline/:trim/:model/:packageCode/accessories" element={<AccessoriesList />} />
            <Route exact path="/:year/:carline/:trim/:model/:packageCode/protections" element={<Protection />} />
            <Route exact path="/:year/:carline/:trim/:model/:packageCode/summary" element={<SummaryPage />} />
            <Route exact path="/:year/:carline/:trim/:model/:packageCode/payments" element={<PaymentsPage />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
